import { Card, CardContent } from "@/components/ui/card";
import { Euro, FileText, AlertTriangle, CheckCircle } from "lucide-react";

// Helper function to format currency (default to EUR for summary)
const formatCurrency = (amount: number, currency = 'EUR') => {
  return new Intl.NumberFormat('el-GR', {
    style: 'currency',
    currency: currency
  }).format(amount);
};

interface InvoiceSummaryProps {
  totalAmount: number;
  paidAmount: number;
  overdueCount: number;
  totalInvoices: number;
}

export function InvoiceSummary({ totalAmount, paidAmount, overdueCount, totalInvoices }: InvoiceSummaryProps) {
  const pendingAmount = totalAmount - paidAmount;
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <FileText className="h-4 w-4 text-primary" />
            <div>
              <p className="text-sm text-muted-foreground">Total Invoices</p>
              <p className="text-lg font-bold">{totalInvoices}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <Euro className="h-4 w-4 text-green-600" />
            <div>
              <p className="text-sm text-muted-foreground">Total Amount</p>
              <p className="text-lg font-bold">{formatCurrency(totalAmount)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <CheckCircle className="h-4 w-4 text-green-600" />
            <div>
              <p className="text-sm text-muted-foreground">Paid</p>
              <p className="text-lg font-bold">{formatCurrency(paidAmount)}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-4">
          <div className="flex items-center space-x-2">
            <AlertTriangle className="h-4 w-4 text-red-600" />
            <div>
              <p className="text-sm text-muted-foreground">Overdue</p>
              <p className="text-lg font-bold">{overdueCount}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}